import { get, post, put, deleted } from '..';
import routes from './routes';

const SaleInvoiceServices = {
  createSaleInvoice: async (obj) => {
    const data = await post(routes.createSaleInvoice, obj);
    return data;
  },
  getSaleInvoices: async (params) => {
    const data = await get(routes.getSaleInvoices, params);
    return data;
  },
  getSaleInvoiceById: async (id) => {
    const data = await get(routes.getSaleInvoiceById + id);
    return data;
  },
  updateSaleInvoice: async (id, obj) => {
    const data = await put(routes.updateSaleInvoice + id, obj);
    return data;
  },
  deleteSaleInvoice: async (id) => {
    const data = await deleted(routes.deleteSaleInvoice + id);
    return data;
  },
  getCustomerByPhone: async (id) => {
    const data = await get(routes.getCustomerByPhone + id);
    return data;
  },
}

export default SaleInvoiceServices